import { URLS, getAPIEndPoint } from "../consts/APIEndpoints";
import { getResponse } from "../utils/common";

const getFilteredRecipientsCount = async (data = {}) => {
    const response = await getResponse(
        `${getAPIEndPoint(URLS.RECIPIENT_FILTER_API)}/count`,
        "post",
        data,
        null
    );
    return response;
};

const getFilteredRecipients = async (data = {}) => {
    const response = await getResponse(
        `${getAPIEndPoint(URLS.RECIPIENT_LIST_API)}`,
        "post",
        data,
        null
    );
    return response;
};

const getAttributeFilterValues = async (data = {}) => {
    const response = await getResponse(
        `${getAPIEndPoint(URLS.RECIPIENT_FILTER_API)}/attributes`,
        "post",
        data,
        null,
    );
    return response;
};

const getFiltersListForTeam = async (teamId) => {
    const response = await getResponse(
        `${getAPIEndPoint(URLS.RECIPIENT_FILTER_API)}/team/${teamId}/saved-filters`,
        "get",
        null,
    );
    return response;
}

const saveFilterAPI = async (data = {}) => {
    const response = await getResponse(
        `${getAPIEndPoint(URLS.RECIPIENT_FILTER_API)}/saved-filters`,
        "put",
        data,
        null
    );
    return response;
}

const updateFilterAPI = async (filterId, data = {}) => {
    const response = await getResponse(
        `${getAPIEndPoint(URLS.RECIPIENT_FILTER_API)}/saved-filters`,
        "put",
        data,
        { filterId }
    );
    return response;
}

const deleteFilterAPI = async (filterId) => {
    const response = await getResponse(
        `${getAPIEndPoint(URLS.RECIPIENT_FILTER_API)}/saved-filters/${filterId}`,
        "delete"
    );
    return response;
}

const downloadRecipientsAPI = async (data = {}) => {
    const response = await getResponse(
        `${getAPIEndPoint(URLS.RECIPIENT_LIST_API)}/download`,
        "post",
        data,
        null
    );
    return response;
};

export {
    getFilteredRecipientsCount,
    getFilteredRecipients,
    getAttributeFilterValues,
    saveFilterAPI,
    updateFilterAPI,
    deleteFilterAPI,
    downloadRecipientsAPI,
    getFiltersListForTeam,
};